const failures: Readonly<Record<string, string>> = {
    DOCUMENTATION_AI_TIMEOUT: "The AI service timed out. Your input is saved; please retry.",
    DOCUMENTATION_AI_INVALID_OUTPUT: "The AI output failed validation after retrying. Your input is saved; please retry.",
    DOCUMENTATION_AI_OUTPUT_TRUNCATED: "The AI output exceeded its token limit. Your input is saved. Please contact an administrator if this repeats.",
    DOCUMENTATION_AI_UNAVAILABLE: "The AI service is temporarily unavailable. Your input is saved; please retry."
};

export function processingFailure(code: string | undefined): string | undefined {
    return code ? failures[code] : undefined;
}
